/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSSVariableValue } from '../../../../../_metronic/assets/ts/_utils'
import { useThemeMode } from '../../../../../_metronic/partials'
import { useDashboardStore } from '../../../../core/state-management/states/dashboard'
import { IDashboard } from '../../../../core/interfaces'

type Props = {
    className: string
    chartColor: string
    chartHeight: string
}

const Mixed: React.FC<Props> = ({ className, chartColor, chartHeight }) => {
    const { state } = useDashboardStore();
    const { dashboardValues } = state
    const chartRef = useRef<HTMLDivElement | null>(null)
    const { mode } = useThemeMode()
    const refreshChart = () => {
        if (!chartRef.current) {
            return
        }

        const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, dashboardValues))
        if (chart) {
            chart.render()
        }

        return chart
    }

    useEffect(() => {
        const chart = refreshChart()

        return () => {
            if (chart) {
                chart.destroy()
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartRef, mode])

    return (
        <div className={`card ${className}`}>
            {/* begin::Body */}
            <div className='card-body p-0 d-flex justify-content-between flex-column overflow-hidden'>
                {/* begin::Hidden */}
                <div className='d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-9 pb-3'>
                    <div className='me-2'>
                        <span className='fw-bold text-gray-800 d-block fs-3'>آمار</span>

                        <span className='text-gray-400 fw-semibold'>تا تاریخ امروز</span>
                    </div>

                    <div className={`fw-bold fs-3 text-${chartColor}`}>
                        همه :
                        {(
                            (dashboardValues?.karogozai?.thisMonthkarogozai || 0) +
                            (dashboardValues?.karogozai?.lastMonthkarogozai || 0) +
                            (dashboardValues?.karogozai?.thisWeekkarogozai || 0) +
                            (dashboardValues?.karogozai?.thisDaykarogozai || 0) +
                            (dashboardValues?.karogozai?.lastDaykarogozai || 0)
                        )}
                    </div>
                </div>
                {/* end::Hidden */}

                {/* begin::Chart */}
                <div ref={chartRef} className='mixed-widget-10-chart'></div>
                {/* end::Chart */}
            </div>
        </div>
    )
}

const chartOptions = (chartColor: string, chartHeight: string, dashboardValues?: IDashboard): ApexOptions => {
    const labelColor = getCSSVariableValue('--bs-gray-500')
    const borderColor = getCSSVariableValue('--bs-gray-200')
    const secondaryColor = getCSSVariableValue('--bs-gray-300')
    const baseColor = getCSSVariableValue('--bs-' + chartColor)

    return {
        series: [
            {
                name: ' تعداد ',
                data: [dashboardValues?.karogozai?.thisMonthkarogozai || 0, dashboardValues?.karogozai?.lastMonthkarogozai || 0, dashboardValues?.karogozai?.thisWeekkarogozai || 0, dashboardValues?.karogozai?.thisDaykarogozai || 0, dashboardValues?.karogozai?.lastDaykarogozai || 0],
            },
        ],
        chart: {
            fontFamily: 'inherit',
            type: 'bar',
            height: chartHeight,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '40%',
                borderRadius: 5,
            },
        },
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
        },
        xaxis: {
            categories: ['این ماه', 'ماه قبل', 'این هفته', 'امروز', 'دیروز'],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
        },
        fill: {
            type: 'solid',
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
        },
        tooltip: {
            style: {
                fontSize: '12px',
            },
            y: {
                formatter: function (val) {
                    return val + ' عدد'
                },
            },
        },
        colors: [baseColor, secondaryColor],
        grid: {
            padding: {
                top: 10,
            },
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },
    }
}

export { Mixed }
